// Guard: snippet is rendered in every section so this script tag may
// be inserted multiple times on a single page. Browsers execute each
// occurrence — without this guard, all the animation IIFEs below would
// run N times in parallel and cripple performance.
if (window.__skyfallSeoLoaded) { /* already initialized, skip */ } else {
window.__skyfallSeoLoaded = true;

// ═══ Crosshair ═══
(function() {
  if (window.matchMedia('(pointer: coarse)').matches) return;
  var ch = document.getElementById('crosshair');
  if (!ch) return;
  var x=0,y=0,tx=0,ty=0;
  document.addEventListener('mousemove', function(e){ tx=e.clientX; ty=e.clientY; ch.style.opacity='0.7'; });
  document.addEventListener('mouseleave', function(){ ch.style.opacity='0'; });
  function loop(){ x+=(tx-x)*0.2; y+=(ty-y)*0.2; ch.style.transform='translate('+(x-18)+'px,'+(y-18)+'px)'; requestAnimationFrame(loop); }
  loop();
})();

// ═══ Nav scroll state ═══
(function(){
  var nav = document.getElementById('nav');
  if (!nav) return;
  function s(){ nav.classList.toggle('is-scrolled', window.scrollY>60); }
  window.addEventListener('scroll', s, {passive:true});
})();

// ═══ Marquee duplicate ═══
function initSeoMarquee(){
  var t = document.getElementById('marqueeTrack');
  if (!t || t.dataset.skyfallInited) return;
  t.dataset.skyfallInited = '1';
  t.innerHTML += t.innerHTML;
}

// ═══ Reveal observer ═══
// Re-scannable so customizer-added sections (shopify:section:load) and
// any DOM that arrives after the initial scan still animate in.
var seoRevealIO = null;
function seoScanReveal(){
  if (!('IntersectionObserver' in window)) {
    document.querySelectorAll('.reveal, .reveal-stagger').forEach(function(el){ el.classList.add('is-in'); });
    return;
  }
  if (!seoRevealIO){
    seoRevealIO = new IntersectionObserver(function(entries){
      entries.forEach(function(e){ if (e.isIntersecting) { e.target.classList.add('is-in'); seoRevealIO.unobserve(e.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
  }
  document.querySelectorAll('.reveal:not(.is-in), .reveal-stagger:not(.is-in)').forEach(function(el){ seoRevealIO.observe(el); });
}
seoScanReveal();
document.addEventListener('shopify:section:load', seoScanReveal);

// ═══ Atlas rail — active section highlight ═══
(function(){
  var rail = document.getElementById('atlasRail');
  if (!rail) return;
  var links = rail.querySelectorAll('a');
  var ids = Array.from(links).map(function(a){ return a.getAttribute('href').slice(1); });
  function update(){
    var bestI = -1, bestY = -Infinity;
    ids.forEach(function(id, i){
      var el = document.getElementById(id);
      if (!el) return;
      var top = el.getBoundingClientRect().top - window.innerHeight * 0.45;
      if (top <= 0 && top > bestY) { bestY = top; bestI = i; }
    });
    links.forEach(function(a, i){ a.classList.toggle('is-active', i === bestI); });
  }
  window.addEventListener('scroll', update, { passive: true });
  update();
})();

// ═══ Magnetic CTAs ═══
(function(){
  if (window.matchMedia('(pointer: coarse)').matches) return;
  document.querySelectorAll('[data-magnetic]').forEach(function(b){
    b.addEventListener('mousemove', function(e){
      var r=b.getBoundingClientRect();
      var x=e.clientX-(r.left+r.width/2), y=e.clientY-(r.top+r.height/2);
      b.style.transform='translate('+(x*0.18)+'px,'+(y*0.18)+'px)';
    });
    b.addEventListener('mouseleave', function(){ b.style.transform=''; });
  });
})();

// ═══ HERO — topographic flyover ═══
function initSeoHero(){
  var c = document.getElementById('heroCanvas');
  if (!c || c.dataset.skyfallInited) return;
  c.dataset.skyfallInited = '1';
  var ctx = c.getContext('2d');
  var W=0, H=0, dpr = Math.min(window.devicePixelRatio||1, 2);
  function resize(){ var r=c.getBoundingClientRect(); W=r.width; H=r.height; c.width=W*dpr; c.height=H*dpr; ctx.setTransform(dpr,0,0,dpr,0,0); }
  resize(); window.addEventListener('resize', resize);

  // Fade the terrain backdrop out as the hero scrolls away — mirrors the
  // social hero's "field fades on scroll" feel. Also flags when the hero has
  // left the viewport so the loop can pause (no simulating behind the page).
  var heroSec = c.closest('.section-seo-hero');
  var visible = true;
  function fadeOnScroll(){
    if (!heroSec) return;
    var r = heroSec.getBoundingClientRect();
    var p = Math.min(1, Math.max(0, -r.top / (window.innerHeight * 0.6)));
    c.style.opacity = (1 - p).toFixed(3);
    visible = r.bottom > 0 && r.top < window.innerHeight;
  }
  window.addEventListener('scroll', fadeOnScroll, { passive: true });
  fadeOnScroll();

  // Procedural terrain field. We sample a low-frequency value-noise function
  // and draw isolines (contour lines) at fixed elevation intervals.
  // It looks like an antique map flyover.

  // Hash-based smooth value noise
  function hash(ix, iy){ var s = Math.sin(ix * 374.31 + iy * 561.13) * 91237.7; return s - Math.floor(s); }
  function smoothstep(t){ return t*t*(3-2*t); }
  function valNoise(x, y){
    var ix=Math.floor(x), iy=Math.floor(y), fx=x-ix, fy=y-iy;
    var a=hash(ix,iy), b=hash(ix+1,iy), c=hash(ix,iy+1), d=hash(ix+1,iy+1);
    var ux=smoothstep(fx), uy=smoothstep(fy);
    return (a*(1-ux)+b*ux)*(1-uy) + (c*(1-ux)+d*ux)*uy;
  }
  function fbm(x, y){
    var v=0, amp=0.5, freq=1;
    for (var i=0;i<4;i++){ v += amp * valNoise(x*freq, y*freq); freq*=2; amp*=0.5; }
    return v;
  }

  // "Peaks" — hotspot search terms with labels. Each carries its own
  // velocity so it drifts across the canvas; bounce at the edges keeps
  // labels on-screen. The contour height-field bakes the peak positions
  // each frame, so the topographic ridges flow with the moving peaks.
  var peaks = [
    { x: 0.22, y: 0.32, vx:  0.00060, vy:  0.00038, label: 'INTENT · Q1',   code: '0.94' },
    { x: 0.72, y: 0.40, vx: -0.00050, vy:  0.00065, label: 'CLUSTER · α',   code: '1.22' },
    { x: 0.46, y: 0.66, vx:  0.00033, vy: -0.00045, label: 'PILLAR · 04',   code: '0.81' },
    { x: 0.78, y: 0.55, vx: -0.00072, vy: -0.00028, label: 'ENTITY · Σ',    code: '1.04' },
    { x: 0.12, y: 0.78, vx:  0.00080, vy: -0.00058, label: 'CITATION · 18', code: '0.66' }
  ];
  var PEAK_BOUNDS = { xMin: 0.06, xMax: 0.78, yMin: 0.20, yMax: 0.82 };

  var t = 0;
  function tick(){
    if (!visible) { requestAnimationFrame(tick); return; }
    t += 0.0014;
    // Drift peaks + bounce at margins so labels stay on-screen
    for (var pp = 0; pp < peaks.length; pp++) {
      var pkm = peaks[pp];
      pkm.x += pkm.vx;
      pkm.y += pkm.vy;
      if (pkm.x < PEAK_BOUNDS.xMin) { pkm.x = PEAK_BOUNDS.xMin; pkm.vx = -pkm.vx; }
      if (pkm.x > PEAK_BOUNDS.xMax) { pkm.x = PEAK_BOUNDS.xMax; pkm.vx = -pkm.vx; }
      if (pkm.y < PEAK_BOUNDS.yMin) { pkm.y = PEAK_BOUNDS.yMin; pkm.vy = -pkm.vy; }
      if (pkm.y > PEAK_BOUNDS.yMax) { pkm.y = PEAK_BOUNDS.yMax; pkm.vy = -pkm.vy; }
    }
    ctx.clearRect(0, 0, W, H);

    // Background subtle wash
    var grad = ctx.createRadialGradient(W*0.5, H*0.55, 0, W*0.5, H*0.55, Math.max(W, H)*0.7);
    grad.addColorStop(0, 'rgba(146,188,221,0.05)');
    grad.addColorStop(1, 'rgba(7,8,10,0.0)');
    ctx.fillStyle = grad; ctx.fillRect(0,0,W,H);

    // Build height field on a coarse grid; draw contour lines via marching-squares-lite
    var step = 12;                        // grid pitch
    var nx = Math.ceil(W / step) + 2;
    var ny = Math.ceil(H / step) + 2;
    // Build a 2D height grid
    var grid = new Float32Array(nx * ny);
    for (var iy=0; iy<ny; iy++){
      for (var ix=0; ix<nx; ix++){
        var fx = (ix * step) / W;
        var fy = (iy * step) / H;
        // Drift the noise plane slowly in x and y
        var hVal = fbm(fx*3.4 + t, fy*3.0 + t*0.6);
        // Bake peaks: gaussian bumps add elevation
        for (var p=0; p<peaks.length; p++){
          var pk = peaks[p];
          var dx = fx - pk.x, dy = fy - pk.y;
          hVal += 0.55 * Math.exp(-(dx*dx + dy*dy) * 22);
        }
        grid[iy*nx + ix] = hVal;
      }
    }

    // Draw filled "low-tint" using just one ribbon for soft look
    ctx.lineCap = 'round'; ctx.lineJoin = 'round';

    // Marching-squares for contours at fixed levels
    var levels = [0.32, 0.42, 0.52, 0.62, 0.72, 0.82, 0.92, 1.02, 1.12, 1.22];
    function lerp(a, b, va, vb, level){ return (level - va) / (vb - va + 1e-9); }

    function drawContour(level, alpha, weight){
      ctx.beginPath();
      for (var iy=0; iy<ny-1; iy++){
        for (var ix=0; ix<nx-1; ix++){
          var v0 = grid[iy*nx + ix];
          var v1 = grid[iy*nx + ix+1];
          var v2 = grid[(iy+1)*nx + ix+1];
          var v3 = grid[(iy+1)*nx + ix];
          var b0 = v0>level?1:0, b1 = v1>level?1:0, b2 = v2>level?1:0, b3 = v3>level?1:0;
          var idx = b0 | (b1<<1) | (b2<<2) | (b3<<3);
          if (idx === 0 || idx === 15) continue;
          var x0 = ix*step, y0 = iy*step;
          // Edge intersections
          var e_top    = [x0 + step*lerp(0,1,v0,v1,level), y0];
          var e_right  = [x0 + step,                       y0 + step*lerp(0,1,v1,v2,level)];
          var e_bottom = [x0 + step*lerp(0,1,v3,v2,level), y0 + step];
          var e_left   = [x0,                              y0 + step*lerp(0,1,v0,v3,level)];
          function seg(a, b){ ctx.moveTo(a[0], a[1]); ctx.lineTo(b[0], b[1]); }
          // 16-case lookup
          switch(idx){
            case 1: case 14: seg(e_top, e_left); break;
            case 2: case 13: seg(e_top, e_right); break;
            case 3: case 12: seg(e_left, e_right); break;
            case 4: case 11: seg(e_right, e_bottom); break;
            case 5:          seg(e_top, e_left); seg(e_right, e_bottom); break;
            case 6: case 9:  seg(e_top, e_bottom); break;
            case 7: case 8:  seg(e_left, e_bottom); break;
            case 10:         seg(e_top, e_right); seg(e_left, e_bottom); break;
          }
        }
      }
      ctx.strokeStyle = 'rgba(146,188,221,' + alpha + ')';
      ctx.lineWidth = weight;
      ctx.stroke();
    }

    for (var li=0; li<levels.length; li++){
      var lv = levels[li];
      // Highlight every third line — major contour, brighter and thicker
      var isMajor = li % 3 === 0;
      drawContour(lv, isMajor ? 0.42 : 0.18, isMajor ? 1.0 : 0.55);
    }

    // ─── Peaks: glowing nodes with mono labels & elevation codes ───
    ctx.font = '9px JetBrains Mono, monospace';
    ctx.textAlign = 'left';
    for (var p2=0; p2<peaks.length; p2++){
      var pk2 = peaks[p2];
      var px = pk2.x * W, py = pk2.y * H;
      // Pulsing ring
      var pulse = 4 + Math.sin(t*40 + p2)*1.2;
      ctx.strokeStyle = 'rgba(146,188,221,0.35)';
      ctx.lineWidth = 0.6;
      ctx.beginPath(); ctx.arc(px, py, 14 + pulse*0.4, 0, Math.PI*2); ctx.stroke();
      // Core glow
      ctx.shadowColor = '#ffe8a3'; ctx.shadowBlur = 14;
      ctx.fillStyle = '#ffe8a3';
      ctx.beginPath(); ctx.arc(px, py, 3, 0, Math.PI*2); ctx.fill();
      ctx.shadowBlur = 0;
      // Tag with bracket lines
      ctx.strokeStyle = 'rgba(146,188,221,0.55)';
      ctx.lineWidth = 0.5;
      ctx.beginPath(); ctx.moveTo(px+5, py); ctx.lineTo(px+22, py-12); ctx.lineTo(px+96, py-12); ctx.stroke();
      ctx.fillStyle = 'rgba(235,217,168,0.95)';
      ctx.fillText(pk2.label, px + 24, py - 16);
      ctx.fillStyle = 'rgba(146,188,221,0.65)';
      ctx.fillText('Δ ' + pk2.code, px + 24, py - 4);
    }

    // ─── Reticle / compass — corner motif ───
    ctx.strokeStyle = 'rgba(146,188,221,0.25)';
    ctx.lineWidth = 0.5;
    ctx.beginPath();
    var ccx = W - 90, ccy = H - 90;
    ctx.arc(ccx, ccy, 38, 0, Math.PI*2);
    ctx.arc(ccx, ccy, 26, 0, Math.PI*2);
    ctx.moveTo(ccx-44, ccy); ctx.lineTo(ccx+44, ccy);
    ctx.moveTo(ccx, ccy-44); ctx.lineTo(ccx, ccy+44);
    ctx.stroke();
    ctx.fillStyle = 'rgba(235,217,168,0.6)';
    ctx.font = '8px JetBrains Mono, monospace';
    ctx.textAlign = 'center';
    ctx.fillText('N', ccx, ccy - 32);
    ctx.fillText('S', ccx, ccy + 36);
    ctx.fillText('W', ccx - 36, ccy + 3);
    ctx.fillText('E', ccx + 36, ccy + 3);

    requestAnimationFrame(tick);
  }
  tick();
}

// ═══ ATLAS — interactive topographic terrain map ═══
// A draggable, zoomable height field rendered as contour lines + hill
// shading. Six named SEO summits anchor fixed world coordinates. Pan
// with mouse drag (or touch). Zoom with scroll wheel (cursor as anchor)
// or pinch on touch. Idle "weather" — slow cloud-shadow drift — adds
// life without making the terrain itself unstable.
function initSeoAtlas(){
  var c = document.getElementById('atlasCanvas');
  if (!c || c.dataset.skyfallInited) return;
  c.dataset.skyfallInited = '1';
  var ctx = c.getContext('2d');
  var coordEl = document.getElementById('atlasCoord');
  var W=0, H=0, dpr = Math.min(window.devicePixelRatio||1, 2);

  // ─── World state ─────────────────────────────────────────────────
  // worldX, worldY = view center in world units. Scale is locked — pan
  // is the only spatial interaction.
  var worldX = 0, worldY = 0;
  var scale  = 0.95;

  // Drag / pan state
  var isDragging = false;
  var dragLastX = 0, dragLastY = 0;
  var panVx = 0, panVy = 0;     // pan inertia after release

  // Hover state
  var mouseScreen = { x: -1, y: -1, on: false };
  var hoverSummit = -1;

  // Recenter animation — when active, lerp world position back toward
  // (0, 0) over several frames for a smooth glide.
  var recentering = false;

  // ─── Six named summits at fixed world coordinates ─────────────────
  var SUMMITS = [
    { wx: -180, wy: -120, label: 'TOPICS',    code: '0.94', desc: 'Topical authority + cluster coverage' },
    { wx:  220, wy:  -90, label: 'ENTITIES',  code: '1.18', desc: 'Named-entity recognition + relationships' },
    { wx:  -90, wy:   60, label: 'CITATIONS', code: '0.81', desc: 'Earned references + backlink graph' },
    { wx:  170, wy:  120, label: 'SCHEMA',    code: '0.96', desc: 'Structured data + rich-result eligibility' },
    { wx: -280, wy:  180, label: 'PILLARS',   code: '0.72', desc: 'Pillar-page architecture + internal linking' },
    { wx:  340, wy: -200, label: 'EEAT',      code: '1.24', desc: 'Experience · Expertise · Authority · Trust' }
  ];

  // ─── Noise field (procedural terrain) ─────────────────────────────
  function hash(ix, iy){ var s = Math.sin(ix * 374.31 + iy * 561.13) * 91237.7; return s - Math.floor(s); }
  function smoothstep(t){ return t*t*(3 - 2*t); }
  function valNoise(x, y){
    var ix = Math.floor(x), iy = Math.floor(y), fx = x - ix, fy = y - iy;
    var a = hash(ix, iy), b = hash(ix+1, iy), cc = hash(ix, iy+1), d = hash(ix+1, iy+1);
    var ux = smoothstep(fx), uy = smoothstep(fy);
    return (a*(1-ux) + b*ux) * (1-uy) + (cc*(1-ux) + d*ux) * uy;
  }
  function fbm(x, y){
    var v = 0, amp = 0.5, freq = 0.012;
    for (var i = 0; i < 5; i++){ v += amp * valNoise(x*freq, y*freq); freq *= 2; amp *= 0.5; }
    return v;
  }
  // Returns elevation at world coordinates (wx, wy), 0..~1.6
  function elevation(wx, wy){
    var h = fbm(wx, wy);
    // Bake summit gaussian bumps into the field
    for (var s = 0; s < SUMMITS.length; s++){
      var sm = SUMMITS[s];
      var dx = wx - sm.wx, dy = wy - sm.wy;
      h += 0.65 * Math.exp(-(dx*dx + dy*dy) / 11000);
    }
    return h;
  }

  function resize(){
    var r = c.getBoundingClientRect();
    W = r.width; H = r.height;
    c.width = W*dpr; c.height = H*dpr;
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  }
  resize();
  window.addEventListener('resize', resize);

  // ─── Coord helpers ────────────────────────────────────────────────
  // Screen → world transform: world coord = (screen - center) / scale + worldOffset
  function screenToWorld(sx, sy){
    return { wx: (sx - W/2) / scale + worldX, wy: (sy - H/2) / scale + worldY };
  }
  function worldToScreen(wx, wy){
    return { sx: (wx - worldX) * scale + W/2, sy: (wy - worldY) * scale + H/2 };
  }
  function evXY(e){
    var r = c.getBoundingClientRect();
    var p = (e.touches && e.touches[0]) || e;
    return { x: p.clientX - r.left, y: p.clientY - r.top };
  }
  function findSummitAt(sx, sy){
    for (var i = 0; i < SUMMITS.length; i++){
      var s = SUMMITS[i];
      var p = worldToScreen(s.wx, s.wy);
      var dx = sx - p.sx, dy = sy - p.sy;
      if (dx*dx + dy*dy < 22*22) return i;
    }
    return -1;
  }

  // ─── Interaction ──────────────────────────────────────────────────
  c.addEventListener('mousemove', function(e){
    var p = evXY(e);
    mouseScreen.x = p.x; mouseScreen.y = p.y; mouseScreen.on = true;
    if (isDragging){
      var dxScreen = p.x - dragLastX;
      var dyScreen = p.y - dragLastY;
      worldX -= dxScreen / scale;
      worldY -= dyScreen / scale;
      panVx = -dxScreen / scale;
      panVy = -dyScreen / scale;
      dragLastX = p.x; dragLastY = p.y;
    } else {
      var idx = findSummitAt(p.x, p.y);
      if (idx !== hoverSummit){
        hoverSummit = idx;
        c.style.cursor = idx >= 0 ? 'pointer' : 'grab';
      }
    }
  }, { passive: true });
  c.addEventListener('mouseleave', function(){ mouseScreen.on = false; hoverSummit = -1; });
  c.addEventListener('mousedown', function(e){
    var p = evXY(e);
    isDragging = true;
    dragLastX = p.x; dragLastY = p.y;
    panVx = 0; panVy = 0;
    c.style.cursor = 'grabbing';
    e.preventDefault();
  });
  window.addEventListener('mouseup', function(){
    if (isDragging){
      isDragging = false;
      c.style.cursor = hoverSummit >= 0 ? 'pointer' : 'grab';
    }
  });
  // Touch: drag pan only (no pinch zoom)
  c.addEventListener('touchstart', function(e){
    if (e.touches.length === 1){
      var t1 = e.touches[0];
      var r = c.getBoundingClientRect();
      isDragging = true;
      dragLastX = t1.clientX - r.left; dragLastY = t1.clientY - r.top;
      panVx = 0; panVy = 0;
      e.preventDefault();
    }
  }, { passive: false });
  c.addEventListener('touchmove', function(e){
    if (!isDragging || e.touches.length !== 1) return;
    var r = c.getBoundingClientRect();
    var t1 = e.touches[0];
    var px = t1.clientX - r.left, py = t1.clientY - r.top;
    var dx = px - dragLastX, dy = py - dragLastY;
    worldX -= dx / scale;
    worldY -= dy / scale;
    dragLastX = px; dragLastY = py;
    e.preventDefault();
  }, { passive: false });
  window.addEventListener('touchend', function(){ isDragging = false; });

  // Recenter button — animate world back to origin
  var recenterBtn = document.getElementById('atlasRecenter');
  if (recenterBtn) {
    recenterBtn.addEventListener('click', function(){
      recentering = true;
      panVx = 0; panVy = 0;
    });
  }

  // ─── Render ──────────────────────────────────────────────────────
  var t = 0;
  function tick(){
    t += 0.012;

    // Recenter animation — glide world position back to origin
    if (recentering){
      worldX += (0 - worldX) * 0.10;
      worldY += (0 - worldY) * 0.10;
      panVx = 0; panVy = 0;
      if (Math.abs(worldX) < 0.5 && Math.abs(worldY) < 0.5){
        worldX = 0; worldY = 0;
        recentering = false;
      }
    } else if (!isDragging){
      // Pan inertia after release
      worldX += panVx;
      worldY += panVy;
      panVx *= 0.86;
      panVy *= 0.86;
      if (Math.abs(panVx) < 0.05) panVx = 0;
      if (Math.abs(panVy) < 0.05) panVy = 0;
    }

    ctx.clearRect(0, 0, W, H);

    // ─── Build height grid in world coords for the visible viewport ──
    // Step in screen-pixels — keep visual density constant regardless of zoom
    var stepScreen = 9;
    var stepWorld = stepScreen / scale;
    var nx = Math.ceil(W / stepScreen) + 2;
    var ny = Math.ceil(H / stepScreen) + 2;
    var gridLeftWorld = (-W/2) / scale + worldX - stepWorld;
    var gridTopWorld  = (-H/2) / scale + worldY - stepWorld;

    var grid = new Float32Array(nx * ny);
    for (var iy = 0; iy < ny; iy++){
      for (var ix = 0; ix < nx; ix++){
        var wx = gridLeftWorld + ix * stepWorld;
        var wy = gridTopWorld + iy * stepWorld;
        grid[iy*nx + ix] = elevation(wx, wy);
      }
    }

    // ─── Hill shading: per-cell normal, fake sun from upper-left ────
    // Render each cell as a quad with shading based on height + slope.
    var sunDirX = -0.7, sunDirY = -0.7;
    for (var iy = 0; iy < ny - 1; iy++){
      for (var ix = 0; ix < nx - 1; ix++){
        var v0 = grid[iy*nx + ix];
        var v1 = grid[iy*nx + ix + 1];
        var v2 = grid[(iy+1)*nx + ix];
        var avg = (v0 + v1 + v2 + grid[(iy+1)*nx + ix + 1]) * 0.25;
        // Slope (gradient) approximation
        var dx = (v1 - v0);
        var dy = (v2 - v0);
        // Light intensity: dot product of slope direction and sun direction
        var slopeMag = Math.sqrt(dx*dx + dy*dy);
        var light = 0.5 + ((dx * sunDirX + dy * sunDirY) / (slopeMag + 0.01)) * 0.18;
        light = Math.max(0.15, Math.min(1.0, light));
        // Color: dark at low elevation → champagne at high
        var elev01 = Math.max(0, Math.min(1, (avg - 0.1) / 1.5));
        var r = (12 + elev01 * 220 * light) | 0;
        var g = (14 + elev01 * 188 * light) | 0;
        var b = (20 + elev01 * 110 * light) | 0;
        ctx.fillStyle = 'rgba(' + r + ',' + g + ',' + b + ',' + (0.18 + elev01 * 0.45) + ')';
        ctx.fillRect(ix*stepScreen - stepWorld*scale*0.5, iy*stepScreen - stepWorld*scale*0.5, stepScreen + 1, stepScreen + 1);
      }
    }

    // ─── Cloud shadow drift (subtle weather) ────────────────────────
    var cloudGrad = ctx.createRadialGradient(
      W * (0.5 + Math.sin(t * 0.18) * 0.35),
      H * (0.4 + Math.cos(t * 0.13) * 0.30),
      0,
      W * (0.5 + Math.sin(t * 0.18) * 0.35),
      H * (0.4 + Math.cos(t * 0.13) * 0.30),
      Math.max(W, H) * 0.45
    );
    cloudGrad.addColorStop(0, 'rgba(0, 0, 0, 0.18)');
    cloudGrad.addColorStop(1, 'rgba(0, 0, 0, 0)');
    ctx.fillStyle = cloudGrad;
    ctx.fillRect(0, 0, W, H);

    // ─── Contour lines via marching-squares ─────────────────────────
    var levels = [0.32, 0.42, 0.52, 0.62, 0.72, 0.82, 0.92, 1.02, 1.12, 1.22, 1.32];
    function lerp(va, vb, level){ return (level - va) / (vb - va + 1e-9); }
    function drawContour(level, alpha, weight){
      ctx.strokeStyle = 'rgba(146,188,221,' + alpha + ')';
      ctx.lineWidth = weight;
      ctx.beginPath();
      for (var iy = 0; iy < ny - 1; iy++){
        for (var ix = 0; ix < nx - 1; ix++){
          var v0 = grid[iy*nx + ix];
          var v1 = grid[iy*nx + ix + 1];
          var v2 = grid[(iy+1)*nx + ix + 1];
          var v3 = grid[(iy+1)*nx + ix];
          var b0 = v0 > level ? 1 : 0;
          var b1 = v1 > level ? 1 : 0;
          var b2 = v2 > level ? 1 : 0;
          var b3 = v3 > level ? 1 : 0;
          var idx = b0 | (b1<<1) | (b2<<2) | (b3<<3);
          if (idx === 0 || idx === 15) continue;
          var x0 = ix * stepScreen, y0 = iy * stepScreen;
          var et = [x0 + stepScreen * lerp(v0, v1, level), y0];
          var er = [x0 + stepScreen,                       y0 + stepScreen * lerp(v1, v2, level)];
          var eb = [x0 + stepScreen * lerp(v3, v2, level), y0 + stepScreen];
          var el = [x0,                                    y0 + stepScreen * lerp(v0, v3, level)];
          function seg(a, b){ ctx.moveTo(a[0], a[1]); ctx.lineTo(b[0], b[1]); }
          switch(idx){
            case 1: case 14: seg(et, el); break;
            case 2: case 13: seg(et, er); break;
            case 3: case 12: seg(el, er); break;
            case 4: case 11: seg(er, eb); break;
            case 5:          seg(et, el); seg(er, eb); break;
            case 6: case 9:  seg(et, eb); break;
            case 7: case 8:  seg(el, eb); break;
            case 10:         seg(et, er); seg(el, eb); break;
          }
        }
      }
      ctx.stroke();
    }
    for (var li = 0; li < levels.length; li++){
      var isMajor = li % 3 === 0;
      drawContour(levels[li], isMajor ? 0.42 : 0.16, isMajor ? 1.0 : 0.55);
    }

    // ─── Coordinate grid overlay (faint, every 100 world units) ─────
    ctx.strokeStyle = 'rgba(236,237,238,0.04)';
    ctx.lineWidth = 0.5;
    var gridSpacing = 100;
    var leftWorldVis  = (-W/2) / scale + worldX;
    var rightWorldVis = ( W/2) / scale + worldX;
    var topWorldVis   = (-H/2) / scale + worldY;
    var botWorldVis   = ( H/2) / scale + worldY;
    var firstGX = Math.ceil(leftWorldVis / gridSpacing) * gridSpacing;
    for (var gx = firstGX; gx <= rightWorldVis; gx += gridSpacing){
      var sx = (gx - worldX) * scale + W/2;
      ctx.beginPath(); ctx.moveTo(sx, 0); ctx.lineTo(sx, H); ctx.stroke();
    }
    var firstGY = Math.ceil(topWorldVis / gridSpacing) * gridSpacing;
    for (var gy = firstGY; gy <= botWorldVis; gy += gridSpacing){
      var sy = (gy - worldY) * scale + H/2;
      ctx.beginPath(); ctx.moveTo(0, sy); ctx.lineTo(W, sy); ctx.stroke();
    }

    // ─── Summit markers + labels ────────────────────────────────────
    ctx.font = '10px JetBrains Mono, monospace';
    for (var si = 0; si < SUMMITS.length; si++){
      var sm = SUMMITS[si];
      var p = worldToScreen(sm.wx, sm.wy);
      // Off-screen culling
      if (p.sx < -120 || p.sx > W + 120 || p.sy < -60 || p.sy > H + 60) continue;
      var isHover = si === hoverSummit;
      // Concentric pulsing ring
      var pulseR = 14 + Math.sin(t * 2 + si) * 2 + (isHover ? 6 : 0);
      ctx.strokeStyle = 'rgba(146,188,221,' + (isHover ? 0.85 : 0.45) + ')';
      ctx.lineWidth = isHover ? 1.2 : 0.6;
      ctx.beginPath(); ctx.arc(p.sx, p.sy, pulseR, 0, Math.PI*2); ctx.stroke();
      // Outer faint ring
      ctx.strokeStyle = 'rgba(146,188,221,' + (isHover ? 0.4 : 0.18) + ')';
      ctx.lineWidth = 0.5;
      ctx.beginPath(); ctx.arc(p.sx, p.sy, pulseR + 8, 0, Math.PI*2); ctx.stroke();
      // Glowing core
      ctx.shadowColor = '#ffe8a3'; ctx.shadowBlur = isHover ? 22 : 14;
      ctx.fillStyle = isHover ? '#fff5d4' : '#ffe8a3';
      ctx.beginPath(); ctx.arc(p.sx, p.sy, isHover ? 5 : 3.4, 0, Math.PI*2); ctx.fill();
      ctx.shadowBlur = 0;
      // Label bracket + text (offset upper-right)
      ctx.strokeStyle = 'rgba(146,188,221,' + (isHover ? 0.85 : 0.55) + ')';
      ctx.lineWidth = 0.6;
      ctx.beginPath();
      ctx.moveTo(p.sx + 6, p.sy - 4);
      ctx.lineTo(p.sx + 22, p.sy - 18);
      ctx.lineTo(p.sx + 110, p.sy - 18);
      ctx.stroke();
      ctx.fillStyle = isHover ? 'rgba(255,245,212,1)' : 'rgba(235,217,168,0.95)';
      ctx.textAlign = 'left';
      ctx.fillText(sm.label, p.sx + 24, p.sy - 22);
      // Hover tooltip — description string under the label
      if (isHover){
        ctx.fillStyle = 'rgba(245,235,200,0.9)';
        ctx.font = '9px JetBrains Mono, monospace';
        ctx.fillText(sm.desc, p.sx + 24, p.sy - 8);
        ctx.font = '10px JetBrains Mono, monospace';
      }
    }

    // ─── Your-business beacon (safehaven at world origin) ───────────
    // Anchored at (0, 0) — the client's domain. Bigger, brighter, with
    // a slow concentric pulse so it always reads as the focal point of
    // the chart. Drawn after the summits so it sits on top.
    var bp = worldToScreen(0, 0);
    if (bp.sx > -200 && bp.sx < W + 200 && bp.sy > -120 && bp.sy < H + 120){
      var bPulse = (Math.sin(t * 1.6) + 1) * 0.5;       // 0..1
      var bPulseSlow = (Math.sin(t * 0.9) + 1) * 0.5;   // 0..1, slower
      // Outer expanding ring (radar sweep)
      var ringR = 28 + bPulse * 22;
      ctx.strokeStyle = 'rgba(255,232,163,' + (0.55 - bPulse * 0.45) + ')';
      ctx.lineWidth = 1.2;
      ctx.beginPath(); ctx.arc(bp.sx, bp.sy, ringR, 0, Math.PI*2); ctx.stroke();
      // Mid ring (steady)
      ctx.strokeStyle = 'rgba(255,232,163,0.45)';
      ctx.lineWidth = 0.8;
      ctx.beginPath(); ctx.arc(bp.sx, bp.sy, 22, 0, Math.PI*2); ctx.stroke();
      // Inner ring (counter-pulse)
      ctx.strokeStyle = 'rgba(255,245,212,' + (0.4 + bPulseSlow * 0.5) + ')';
      ctx.lineWidth = 1.4;
      ctx.beginPath(); ctx.arc(bp.sx, bp.sy, 13 + bPulseSlow * 1.5, 0, Math.PI*2); ctx.stroke();
      // Crosshair tick marks (cardinal)
      ctx.strokeStyle = 'rgba(255,232,163,0.65)';
      ctx.lineWidth = 1;
      ctx.beginPath();
      ctx.moveTo(bp.sx, bp.sy - 32); ctx.lineTo(bp.sx, bp.sy - 24);
      ctx.moveTo(bp.sx, bp.sy + 24); ctx.lineTo(bp.sx, bp.sy + 32);
      ctx.moveTo(bp.sx - 32, bp.sy); ctx.lineTo(bp.sx - 24, bp.sy);
      ctx.moveTo(bp.sx + 24, bp.sy); ctx.lineTo(bp.sx + 32, bp.sy);
      ctx.stroke();
      // Glowing core — large, bright white-gold
      ctx.shadowColor = '#fff5d4'; ctx.shadowBlur = 30 + bPulseSlow * 14;
      ctx.fillStyle = '#fff5d4';
      ctx.beginPath(); ctx.arc(bp.sx, bp.sy, 7 + bPulseSlow * 1.5, 0, Math.PI*2); ctx.fill();
      ctx.shadowBlur = 0;
      // Inner highlight
      ctx.fillStyle = 'rgba(255,255,255,0.9)';
      ctx.beginPath(); ctx.arc(bp.sx - 1.5, bp.sy - 1.5, 2.4, 0, Math.PI*2); ctx.fill();
      // Label bracket + text (lower-right offset to avoid summit collisions)
      ctx.strokeStyle = 'rgba(255,232,163,0.85)';
      ctx.lineWidth = 0.8;
      ctx.beginPath();
      ctx.moveTo(bp.sx + 8, bp.sy + 6);
      ctx.lineTo(bp.sx + 26, bp.sy + 26);
      ctx.lineTo(bp.sx + 150, bp.sy + 26);
      ctx.stroke();
      // Tag chip behind the label
      ctx.fillStyle = 'rgba(7,8,11,0.85)';
      ctx.fillRect(bp.sx + 28, bp.sy + 14, 122, 24);
      ctx.strokeStyle = 'rgba(255,232,163,0.55)';
      ctx.lineWidth = 0.6;
      ctx.strokeRect(bp.sx + 28, bp.sy + 14, 122, 24);
      ctx.fillStyle = '#fff5d4';
      ctx.font = 'bold 10px JetBrains Mono, monospace';
      ctx.textAlign = 'left';
      ctx.fillText('YOUR BUSINESS', bp.sx + 34, bp.sy + 30);
      ctx.font = '10px JetBrains Mono, monospace';
      // "SAFEHAVEN" tag below the bracket
      ctx.fillStyle = 'rgba(146,188,221,0.85)';
      ctx.font = '8px JetBrains Mono, monospace';
      ctx.fillText('◆ SAFEHAVEN · BASE OF OPERATIONS', bp.sx + 34, bp.sy + 50);
      ctx.font = '10px JetBrains Mono, monospace';
    }

    // ─── Cursor crosshair (over terrain) ────────────────────────────
    if (mouseScreen.on && !isDragging){
      ctx.strokeStyle = 'rgba(146,188,221,0.30)';
      ctx.lineWidth = 0.5;
      ctx.beginPath();
      ctx.moveTo(mouseScreen.x - 12, mouseScreen.y); ctx.lineTo(mouseScreen.x + 12, mouseScreen.y);
      ctx.moveTo(mouseScreen.x, mouseScreen.y - 12); ctx.lineTo(mouseScreen.x, mouseScreen.y + 12);
      ctx.stroke();
      ctx.strokeStyle = 'rgba(146,188,221,0.5)';
      ctx.beginPath(); ctx.arc(mouseScreen.x, mouseScreen.y, 4, 0, Math.PI*2); ctx.stroke();
    }

    // ─── Compass (top-right corner) ─────────────────────────────────
    var ccx = W - 50, ccy = 50;
    ctx.strokeStyle = 'rgba(146,188,221,0.35)';
    ctx.lineWidth = 0.6;
    ctx.beginPath(); ctx.arc(ccx, ccy, 22, 0, Math.PI*2); ctx.stroke();
    ctx.beginPath(); ctx.arc(ccx, ccy, 14, 0, Math.PI*2); ctx.stroke();
    ctx.beginPath();
    ctx.moveTo(ccx - 26, ccy); ctx.lineTo(ccx + 26, ccy);
    ctx.moveTo(ccx, ccy - 26); ctx.lineTo(ccx, ccy + 26);
    ctx.stroke();
    ctx.fillStyle = 'rgba(146,188,221,0.85)';
    ctx.font = '9px JetBrains Mono, monospace';
    ctx.textAlign = 'center';
    ctx.fillText('N', ccx, ccy - 30);
    ctx.fillStyle = 'rgba(146,188,221,0.55)';
    ctx.fillText('S', ccx, ccy + 36);
    ctx.fillText('E', ccx + 32, ccy + 3);
    ctx.fillText('W', ccx - 32, ccy + 3);
    // Compass needle (always pointing geographic north — i.e., -Y)
    ctx.strokeStyle = 'rgba(255,232,163,0.95)';
    ctx.lineWidth = 1.3;
    ctx.beginPath(); ctx.moveTo(ccx, ccy); ctx.lineTo(ccx, ccy - 18); ctx.stroke();
    ctx.fillStyle = '#ffe8a3';
    ctx.shadowColor = '#ffe8a3'; ctx.shadowBlur = 6;
    ctx.beginPath(); ctx.arc(ccx, ccy, 2.5, 0, Math.PI*2); ctx.fill();
    ctx.shadowBlur = 0;

    // ─── Scale bar (bottom-right) ───────────────────────────────────
    // Show the world distance corresponding to a 100-px screen segment
    var scaleWorldDist = (100 / scale).toFixed(0);
    var sbX = W - 130, sbY = H - 36;
    ctx.strokeStyle = 'rgba(146,188,221,0.65)';
    ctx.lineWidth = 1.2;
    ctx.beginPath();
    ctx.moveTo(sbX, sbY); ctx.lineTo(sbX + 100, sbY);
    ctx.moveTo(sbX, sbY - 4); ctx.lineTo(sbX, sbY + 4);
    ctx.moveTo(sbX + 100, sbY - 4); ctx.lineTo(sbX + 100, sbY + 4);
    ctx.moveTo(sbX + 50, sbY - 2); ctx.lineTo(sbX + 50, sbY + 2);
    ctx.stroke();
    ctx.fillStyle = 'rgba(146,188,221,0.85)';
    ctx.font = '9px JetBrains Mono, monospace';
    ctx.textAlign = 'left';
    ctx.fillText(scaleWorldDist + ' km', sbX, sbY + 16);
    ctx.textAlign = 'right';
    ctx.fillText('SCALE · ' + scale.toFixed(2) + 'x', sbX + 100, sbY + 16);

    // ─── Live coord readout for the canvas frame header ─────────────
    if (coordEl){
      var lat = (45.5 + (-worldY) * 0.0008).toFixed(4);
      var lng = (73.5 + ( worldX) * 0.0008).toFixed(4);
      var elv = elevation(worldX, worldY) * 1248;
      coordEl.textContent = 'N ' + lat + '° · W ' + lng + '° · ELEV ' + elv.toFixed(0);
    }

    // Set initial cursor on first frame
    if (c.style.cursor === '') c.style.cursor = 'grab';

    requestAnimationFrame(tick);
  }
  // Start with cursor=grab and a small drift toward EEAT (the highest summit)
  c.style.cursor = 'grab';
  worldX = 0; worldY = 0;
  tick();
}

// ═══ THE CLIMB — animated rank ascent (rank 88 → rank 1) ═══
// A continuous animation: domain starts at rank 88, climbs steadily up
// through the SERP. Top-10 ladder shows competitor rows; the user row
// stays "below the visible page" until rank ≤ 10, then enters the ladder
// at the bottom and climbs row-by-row to position 1, displacing
// competitors downward. Loops with a pause at rank 1.
function initSeoClimb(){
  var rowsHost = document.getElementById('ladderRows');
  if (!rowsHost || rowsHost.dataset.skyfallInited) return;
  rowsHost.dataset.skyfallInited = '1';
  var rankEl     = document.getElementById('climbRank');
  var bigRankEl  = document.getElementById('climbBigRank');
  var stageEl    = document.getElementById('climbStage');
  var progressEl = document.getElementById('climbProgress');

  // Top-10 competitors — fixed order, never reshuffled.
  var COMPS = [
    'forbes.com / category-guide',
    'gartner.com / quadrant-2026',
    'the-incumbent.com / index',
    'wirecutter.nyt.com / picks',
    'industry-mag.com / report',
    'reddit.com / r/category-thread',
    'category-blog.io / vs-comparison',
    'review-site.io / 2026-edition',
    'cms-incumbent.com / hub',
    'capterra.com / shortlist'
  ];
  // Long-tail competitors for ranks 11+. Deterministic per rank so the
  // same URL always shows at the same position when the camera scrolls
  // past it again.
  var LT_SLUGS = [
    'affiliate-roundup', 'small-blog', 'forum-thread', 'review-aggregator',
    'topic-wiki', 'comparison-grid', 'guide-site', 'directory-listing',
    'old-content', 'industry-news', 'aggregator-feed', 'long-tail-blog',
    'archive-post', 'side-publication'
  ];
  var LT_TLDS = ['.com', '.io', '.net', '.co', '.org'];
  function compFor(rank){
    if (rank <= 10) return COMPS[(rank - 1) % COMPS.length];
    var slug = LT_SLUGS[(rank * 7) % LT_SLUGS.length];
    var tld  = LT_TLDS[(rank * 3) % LT_TLDS.length];
    return slug + '-' + ((rank * 13) % 99) + tld + ' / page';
  }

  // Animation params — runs ONCE on first viewport entry, then locks at
  // rank 1 permanently. No loop = no jarring jump-back to rank 88.
  var START_RANK     = 88;
  var END_RANK       = 1;
  var CLIMB_DURATION = 5500;   // ms — full ascent

  // Stage labels — surface the "page" the user is currently on, plus
  // the moment they break into the top 10.
  function stageFor(rank){
    if (rank > 80) return 'PAGE 9 · BURIED';
    if (rank > 70) return 'PAGE 8 · INVISIBLE';
    if (rank > 60) return 'PAGE 7 · NO TRAFFIC';
    if (rank > 50) return 'PAGE 6 · UNDISCOVERED';
    if (rank > 40) return 'PAGE 5 · CRAWLING';
    if (rank > 30) return 'PAGE 4 · CLIMBING';
    if (rank > 20) return 'PAGE 3 · GAINING';
    if (rank > 10) return 'PAGE 2 · ALMOST THERE';
    if (rank > 3)  return 'PAGE 1 · TOP 10';
    if (rank > 1)  return 'PAGE 1 · TOP 3';
    return '▸ POSITION ONE ◂';
  }

  // Build a row element for either a competitor (pos = 1..10) or the user row.
  // Competitor rows persist; the user row is rebuilt each time its rank changes.
  function makeRow(pos, url, delta, isYou){
    var row = document.createElement('div');
    row.className = 'rung' + (isYou ? ' rung--you' : '');
    row.innerHTML =
      '<div class="rung__pos">' + (pos < 10 ? '0' + pos : pos) + '</div>' +
      '<div class="rung__url">' + url + '</div>' +
      '<div class="rung__delta">Δ ' + delta + '</div>';
    return row;
  }

  // Render a 10-row "camera" window that follows the user up the SERP.
  // The user's row sits at slot 7 (4th from bottom) for the long climb
  // through pages 9 → 2, so they're always visible with surrounding
  // competitors. Once rank ≤ 7, the window locks at ranks 1–10 and the
  // user row physically moves up the slots: 7 → 6 → … → 1.
  function getWindowStart(userRank){
    if (userRank <= 7) return 1;
    return userRank - 6;
  }
  function render(currentRank, lastDelta){
    rowsHost.innerHTML = '';
    var winStart = getWindowStart(currentRank);
    for (var i = 0; i < 10; i++){
      var pos = winStart + i;
      var isUser = pos === currentRank;
      if (isUser){
        rowsHost.appendChild(makeRow(pos, 'your-domain.com / pillar-page', lastDelta, true));
      } else {
        rowsHost.appendChild(makeRow(pos, compFor(pos), '—', false));
      }
    }
  }

  // ─── One-shot climb animation ───
  var phaseStart = 0;
  var lastShownRank = START_RANK;
  var done = false;

  // Quart ease-out — fast at first, gentle at the end (hangs on the
  // dramatic final positions before locking at #1).
  function easeOutQuart(p){ return 1 - Math.pow(1 - p, 4); }

  function frame(now){
    if (done) return;                 // animation finished — stop entirely
    var elapsed = now - phaseStart;
    var t = Math.min(1, elapsed / CLIMB_DURATION);
    var eased = easeOutQuart(t);
    var rank = START_RANK - eased * (START_RANK - END_RANK);
    var rankInt = Math.max(END_RANK, Math.round(rank));

    // Compute a smooth running delta (positions gained since last shown rank)
    var delta = lastShownRank - rankInt;
    var deltaStr = delta > 0 ? '+' + delta : '—';

    // Update big counter + small chip
    bigRankEl.textContent = rankInt;
    rankEl.textContent = 'RANK · ' + (rankInt < 10 ? '0' + rankInt : rankInt);
    stageEl.textContent = stageFor(rankInt);
    progressEl.style.width = (eased * 100).toFixed(2) + '%';

    // Re-render the ladder only when the integer rank changes
    if (rankInt !== lastShownRank){
      render(rankInt, deltaStr);
      lastShownRank = rankInt;
    }

    if (t >= 1){
      // Reached rank 1 — lock the final state, flag the glow, stop the rAF
      bigRankEl.classList.add('is-arrived');
      bigRankEl.textContent = END_RANK;
      rankEl.textContent = 'RANK · 0' + END_RANK;
      stageEl.textContent = stageFor(END_RANK);
      progressEl.style.width = '100%';
      render(END_RANK, '+87');
      // Stop the breathing/floating effect — the row planted at #1
      var userRow = rowsHost.querySelector('.rung--you');
      if (userRow) userRow.classList.add('rung--locked');
      done = true;
      return;
    }
    requestAnimationFrame(frame);
  }

  // Initial paint + start animation when section enters view
  render(START_RANK, '—');
  bigRankEl.textContent = START_RANK;
  rankEl.textContent = 'RANK · ' + START_RANK;
  stageEl.textContent = stageFor(START_RANK);

  var rafStarted = false;
  function startAnimation(){
    if (rafStarted) return;
    rafStarted = true;
    phaseStart = performance.now();
    requestAnimationFrame(frame);
  }
  if ('IntersectionObserver' in window){
    var section = document.getElementById('climb');
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){ if (e.isIntersecting) startAnimation(); });
    }, { threshold: 0.25 });
    io.observe(section);
  } else {
    startAnimation();
  }
}

// ═══ THE LEDGER — earned-media feed ═══
function initSeoLedger(){
  var track = document.getElementById('ledgerTrack');
  if (!track || track.dataset.skyfallInited) return;
  track.dataset.skyfallInited = '1';
  if (!track) return;
  // Fictional but plausible publication / headline / domain / DR / status
  var ENTRIES = [
    ['04 · MAR', 'Why operators are ditching the legacy stack',                    'industry-weekly.com',     '78', 'CITED'],
    ['28 · FEB', 'A founder\'s case against quarterly contracts',                  'thefounderletter.co',     '64', 'PUB'],
    ['22 · FEB', 'The category leader\'s playbook, examined',                       'forbes.com',              '94', 'PUB'],
    ['19 · FEB', 'Field notes from a 200-domain audit',                            'searchjournal.io',        '71', 'CITED'],
    ['11 · FEB', 'Inside the SEO operations team that hit pos. 1',                 'martechtoday.com',        '76', 'PUB'],
    ['07 · FEB', 'On schema, cited correctly',                                      'wired.com',               '92', 'CITED'],
    ['02 · FEB', 'Why AI overviews aren\'t the death of organic',                  'theverge.com',            '90', 'CITED'],
    ['28 · JAN', 'A working theory of topical authority',                          'cxl.com',                 '74', 'PUB'],
    ['22 · JAN', 'The case for in-house writing teams',                             'cmswire.com',             '72', 'PUB'],
    ['16 · JAN', 'How operators are reading the SERP',                              'fastcompany.com',         '88', 'CITED'],
    ['11 · JAN', 'A new shape for the content org',                                 'hbr.org',                 '93', 'PUB'],
    ['04 · JAN', 'On the discipline of internal linking',                            'searchenginejournal.com', '82', 'CITED'],
    ['28 · DEC', 'The agency that made it home for Q4',                              'adweek.com',              '85', 'PUB'],
    ['18 · DEC', 'Citations, reframed',                                              'theatlantic.com',         '93', 'CITED']
  ];
  var html = ENTRIES.map(function(e){
    return '<div class="ledger__row">' +
      '<div class="ld">' + e[0] + '</div>' +
      '<div class="lt">' + e[1] + '</div>' +
      '<div class="lp">' + e[2] + '</div>' +
      '<div class="ldr">' + e[3] + '</div>' +
      '<div class="lst">' + e[4] + '</div>' +
    '</div>';
  }).join('');
  // Duplicate so the loop scroll feels seamless
  track.innerHTML = html + html;
}

// ═══ Section init registry ═══
// Each named init fn is idempotent (data-skyfall-inited guard). We call
// them on initial load and on shopify:section:load so customizer-added
// or reloaded sections animate correctly.
function seoInitAll(){
  initSeoMarquee();
  initSeoHero();
  initSeoAtlas();
  initSeoClimb();
  initSeoLedger();
}
seoInitAll();
document.addEventListener('shopify:section:load', seoInitAll);

} // /__skyfallSeoLoaded guard
